import * as methods from '~/configs/methods'
import vm from '~/main'
export default {
  $userCheckAccess: (data) => {
    return methods.userCheckAccess(data)
  },
  $routerCheckAccess: (routName) => {
    const userType = store.getters['user/userType']
    if (userType !== 'superadmin') {
      console.log('$routerCheckAccess', vm.$router.options.routes)
      vm.$router.currentRoute.matched.some((route) => {
        if (route.meta.access) {
          if (route.meta.access.userType && route.meta.access.abilities) {
            if (route.meta.access.userType !== userType) {
              return false
            } else if (
              !this.$userCheckAccess({
                abilities: route.meta.access.abilities,
              })
            ) {
              return false
            }
          } else if (
            route.meta.access.abilities &&
            !this.$userCheckAccess({
              abilities: route.meta.access.abilities,
            })
          ) {
            return false
          } else {
            return true
          }
        } else return true
      })
    } else return true
  }
}